import getters from './getters';
import mutations from './mutations';
import actions from './actions';
function initState() {
    return {
        agentInfo: {}
    };
}

export default {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
};
